import React from 'react';
import { Calendar, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import type { UserHolidayStats } from '../../../utils/types';

interface HolidayStatsCardProps {
  stats: UserHolidayStats | undefined;
  isLoading?: boolean;
}

export const HolidayStatsCard: React.FC<HolidayStatsCardProps> = ({ stats, isLoading }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-lg shadow p-4 animate-pulse">
            <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  const statItems = [
    {
      label: 'Allocated',
      value: stats?.allocated ?? 0,
      icon: Calendar,
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      iconColor: 'text-blue-500',
    },
    {
      label: 'Taken',
      value: stats?.taken ?? 0,
      icon: CheckCircle,
      color: 'bg-green-50 text-green-700 border-green-200',
      iconColor: 'text-green-500',
    },
    {
      label: 'Remaining',
      value: stats?.remaining ?? 0,
      icon: AlertCircle,
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      iconColor: 'text-amber-500',
    },
    {
      label: 'Pending',
      value: stats?.pending ?? 0,
      icon: Clock,
      color: 'bg-purple-50 text-purple-700 border-purple-200',
      iconColor: 'text-purple-500',
    },
  ];

  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {stats?.year ?? new Date().getFullYear()} Holiday Balance
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {statItems.map((item) => (
          <div
            key={item.label}
            className={`rounded-lg border p-4 ${item.color}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium opacity-80">{item.label}</p>
                <p className="text-2xl font-bold mt-1">{item.value}</p>
              </div>
              <item.icon className={`w-8 h-8 ${item.iconColor} opacity-60`} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolidayStatsCard;
